import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { useCases } from '../../data/content';

/** Section 8 — different ways to teach with it. */
export function UseCasesSection() {
  return <section aria-labelledby="usecases-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-195" data-mp="12sjnwb8o65qk">
      <div className="mx-auto max-w-5xl" data-id="element-196" data-mp="xvbep05i1c1g">
        <SectionHeading id="usecases-heading" title={<>
              One System. <Accent data-id="element-198" data-mp="1vjuy4ec9kymn">Different Ways to Teach.</Accent>
            </>} data-id="element-197" data-mp="xwcs3b9zmamc" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-199" data-mp="1ql0hnj1rrm5p">
          {useCases.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex h-full flex-col rounded-[20px] bg-white px-6 py-7" data-id="element-200" data-mp="1gtw0qdsj9r88">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-lavender text-brand-plum" data-id="element-201" data-mp="2e8rsei7nvr4v">
                <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-202" data-mp="29h030b08rrgb" />
              </span>
              <h3 className="mt-5 font-body text-[13px] font-bold uppercase tracking-[0.12em] text-brand-charcoal" data-id="element-203" data-mp="vdr17zgneqfb">
                {title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-204" data-mp="lnxq0zkf4dbl">{description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}